import type { FaireProductEntity } from "../../entity_types/product";

export const p_sd2ze3wt9c: FaireProductEntity = {
  token: "p_sd2ze3wt9c",
  type: "product",
  name: "Mini Aircare Duo",
  brandToken: "b_8aa5kchc2z",
  brandName: "Homecourt",
  imageUrl:
    "https://cdn.faire.com/fastly/1155c2175f36b0b58be575b5b97fb814352df1bde3cabd2174057121db8be585.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/076e323f23271dd7d57273e45e1101b662bfb6d7d9548ff23e39575e591b8174.jpeg",
  ],
  priceDollars: 26.95,
  description:
    "Bring the essence of Homecourt into every room this holiday season. This limited-edition miniduo features our award-winning Cece Mini Room Deodorant (1 oz) and Cece Votive Candle (2.25 oz)—a perfectly paired set to purify the air and infuse your space with fine fragrance.\n\nThe Room Deodorant, a 3× Allure Best of Beauty Award winner, neutralizes odors with a sophisticated scent, while the votive candle creates an inviting glow. Together, they refresh, elevate, and set the tone for a beautifully scented holiday home.\n",
  tags: [],
  msrpDollars: 49,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-04-28T15:36:24.003Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
